import API from "../assets/API.jpg";
import Enzymes from "../assets/Enzymes.jpg";
import Pipeline from "../assets/Pipeline.jpg";
import Probiotics from "../assets/Probiotics.jpg";
import Vitamin from "../assets/Vitamin.jpeg";
import Nutextracts from "../assets/Nutextracts.jpg";

export const ProdList = [
  {
    name: "Active Pharmaceutical Ingredients",
    image: API,
    
  },
  {
    name: "Enzymes",
    image: Enzymes,
  
  },
  {
    name: "Pipeline Products",
    image: Pipeline,
    
  },
  {
    name: "Probiotics-Customised",
    image: Probiotics,
    
  },
  {
    name: "Vitamin Analogues",
    image: Vitamin,
    
  },
  {
    name: "Nutritional Actives and Extracts",
    image: Nutextracts,
    
  },
];
